import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { UtilityService } from '@irb/irb-common/services/utility.service';
import { IrbSettingsService } from '@irb/irb-settings/irb-settings.service';
import { IGlobalSettings, IGlobalSettingsSaveResponse } from '@irb/irb-settings/irb-settings.model';
import { ISMANotAllowedResponse } from '@irb/irb-settings/settings-accounts/settings-accounts.model';
import { AppService } from '@irb/app.service';
import { IEvent, IrbSettingsEvents, IrbAppEvents } from '@irb-common/events';
import { PageService } from '@irb-common/services/page.service';
import { Subscription, Observable, of } from 'rxjs';
import { SettingsPage } from '@irb/irb-settings/irb-settings.page';
import { DataTransferService } from '@irb/irb-common/services/data-transfer.service';
import { IrbAuthenticationService } from '@irb/irb-authentication/irb-authentication.service';
import { IAlertDialogData } from '@irb/app.model';
import { AnalyticsService } from "@irb-common/analytics/analytics.service";
import { IDropdownItem } from '@irb/irb-common/models/dropdown.model';
import { DropdownFilterComponent } from '@irb/irb-common/components/dropdown-filter/dropdown-filter.component';

@Component({ standalone: false,
  selector: 'irb-settings-accounts',
  templateUrl: './settings-accounts.component.html',
  styleUrls: ['./settings-accounts.component.scss','../../irb-common/styles/dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsAccountsComponent implements SettingsPage<IGlobalSettings>, OnInit, OnDestroy {
  @ViewChild('taxableCashMinPerc') taxableCashMinPerc: any;
  @ViewChild('taxableCashMinDollarAmnt') taxableCashMinDollarAmnt: any;
  @ViewChild('taxableCashMaxPerc') taxableCashMaxPerc: any;
  @ViewChild('taxableCashTargetPerc') taxableCashTargetPerc: any;
  @ViewChild('qualifiedCashMinPerc') qualifiedCashMinPerc: any;
  @ViewChild('qualifiedCashMinDollarAmnt') qualifiedCashMinDollarAmnt: any;
  @ViewChild('qualifiedCashMaxPerc') qualifiedCashMaxPerc: any;
  @ViewChild('qualifiedCashTargetPerc') qualifiedCashTargetPerc: any;
  @ViewChild('autoCashHoldForDistWindow') autoCashHoldForDistWindow: any;
  @ViewChild('showExternalAccountsPos') showExternalAccountsPos: any;
  @ViewChild('showExternalAccountsNeg') showExternalAccountsNeg: any;
  @ViewChild('isSMAallowedPos') isSMAallowedPos: any;
  @ViewChild('isSMAallowedNeg') isSMAallowedNeg: any;
  @ViewChild('reinvestUnsupportedConfigMessage') reinvestUnsupportedConfigMessage: TemplateRef<any>;
  @ViewChild('autoCashPanel') autoCashPanel: any;
  @ViewChild('quailifiedTrxCashMinValueRef') quailifiedTrxCashMinValueRef: any;
  @ViewChild('taxableTrxCashMinValueRef') taxableTrxCashMinValueRef: any;


  @Input('onFirstLoad') onFirstLoad: Function;
  @Output() onFirstLoadChange: EventEmitter<Function> = new EventEmitter<Function>();

  _globalSettings: IGlobalSettings;
  originalGlobalSettings: IGlobalSettings;
  _isModified: boolean;
  eventSubscription: Subscription;
  showUnsavedChangesWarning: boolean = false;
  cashSettingsPlaceholderDefault: string = '1.0%';
  cashSettingsPlaceholder = this.cashSettingsPlaceholderDefault;
  cashSettingsPlaceholderDollarDefault: string = '$1';
  cashSettingsPlaceholderDollar = this.cashSettingsPlaceholderDollarDefault;
  defaultExpandedPanels:Array<string> = ["HISTORY","REINVEST_OPTIONS","ACCOUNT_CASH","EXTERNAL_ACCOUNTS","SMA","SHORT_CASH"];
  _isadmin:boolean = false;
  isDistHoldCashEnabled: boolean;
  validationErrors: string[];
  validationErrorTemplates: TemplateRef<any>[];
  uiReady: boolean = false;
  isUiTest: boolean = false;

  percentagePlaceholder: string = '0.00 %';
  taxableTrxCashMinValue: number;
  quailifiedTrxCashMinValue: number;
  isCashEqvEnabled: boolean;
  ENABLE_SETTINGS_HIST = false;

  constructor(
    public iss: IrbSettingsService, 
    private cdr: ChangeDetectorRef, 
    private util: UtilityService, 
    private as: AppService, 
    private ps: PageService,
    public dataTransferService: DataTransferService,
    public ias:IrbAuthenticationService,
    public ats: AnalyticsService) {
      this.ats.trackGlobalSettingsAccountsEvent();
      this.eventSubscription = this.as.getEvents().subscribe((s) => { this.processEvent(s); });
      const irbAppConfig  = this.as.getItem("IRB_APP_CONFIG");
      if (irbAppConfig) {
        this.isadmin = irbAppConfig.isAdmin || false;
        this.isCashEqvEnabled = irbAppConfig.featureFlags.isCashEqvEnabled || false;
        this.isDistHoldCashEnabled = irbAppConfig.featureFlags.isDistHoldCashEnabled || false;
        this.ENABLE_SETTINGS_HIST = irbAppConfig.featureFlags?.ENABLE_SETTINGS_HIST || false;
      }
      if(this.isDistHoldCashEnabled) {
        this.defaultExpandedPanels.push("AUTO_CASH");
      }
    }

  ngOnInit() {
    this.ps.deserializePageState(this.as.getFromSession("pageState"),["accountGridDiv"]);
    if (!this.ENABLE_SETTINGS_HIST) {
      this.defaultExpandedPanels = this.defaultExpandedPanels.filter(p => p !== 'HISTORY');
    }
    this.iss.loadExpansionState(this.defaultExpandedPanels.length,"settings-accounts-" + this.defaultExpandedPanels.length,this.defaultExpandedPanels);
    if (this.ENABLE_SETTINGS_HIST) {
      this.iss.updateExpansionState('HISTORY','closed');
    }
    this.cdr.detectChanges();
  
    this.iss.getGlobalSettings().subscribe((data: any) => {
      data.distWindowMin = data.distWindowMin || 2;
      data.distWindowMax = data.distWindowMax || 30;
      if (this.isCashEqvEnabled) {
        if (data.taxableTrxCashMinValue === null) {data.taxableTrxCashMinValue = 0;}
        if (data.quailifiedTrxCashMinValue === null) {data.quailifiedTrxCashMinValue = 0;}
      }
      this.taxableTrxCashMinValue = data.taxableTrxCashMinValue;
      this.quailifiedTrxCashMinValue = data.quailifiedTrxCashMinValue;
      if(this.onFirstLoad) {
        this.onFirstLoad();
        this.onFirstLoadChange.emit(null);
      }

      this.load(data as IGlobalSettings);

      if (!this.isUiTest) {
        setTimeout(() => {
          this.uiReady = true;
          this.cdr.detectChanges();
        }, 2000);
      }
    });
  }

  ngOnDestroy() {
    this.eventSubscription.unsubscribe();
  }

  refreshData() {
    this.iss.getGlobalSettings().subscribe((data: any) => {
      this.load(data as IGlobalSettings);
    });
    this.cdr.detectChanges();
  }

  onInputChange() {
    window.setTimeout(() => {
      const ignore: Array<string> = (this.globalSettings.useModelCash) ? [
        "taxableCashMinPerc",
        "taxableCashTargetPerc",
        "taxableCashMaxPerc",
        "taxableCashMinDollarAmnt",
        "qualifiedCashMinPerc",
        "qualifiedCashTargetPerc",
        "qualifiedCashMaxPerc",
        "qualifiedCashMinDollarAmnt"
      ] : [];

      this.isModified = !this.util.compare(this.originalGlobalSettings,this.globalSettings,ignore);
      this.as.fireEvent((this.isModified) ? IrbSettingsEvents.IS_MODIFIED : IrbSettingsEvents.IS_NOT_MODIFIED);
      this.cdr.detectChanges();
      this.validateInput().subscribe(_validationErrors => {});
    });
  }
  onTaxableTrxCashMinValueChange() {
    this.globalSettings.taxableTrxCashMinValue = this.taxableTrxCashMinValue;
    this.onInputChange();
  }
  onQuailifiedTrxCashMinValueChange() {
    this.globalSettings.quailifiedTrxCashMinValue = this.quailifiedTrxCashMinValue;
    this.onInputChange();
  }
  onShowExternalAccountsPosClick() {
    if(!this.isDisabled()) {
      this.globalSettings.showExternalAccounts = true;
      this.onInputChange();
    }
  }

  onShowExternalAccountsNegClick() {
    if(!this.isDisabled()) {
      this.globalSettings.showExternalAccounts = false;
      this.onShowExternalAccountsChange();
    }
  }

  onUseModelCashChange() {
    if(this.globalSettings.useModelCash) {
      this.cashSettingsPlaceholder = "Using model targets";
      this.cashSettingsPlaceholderDollar = "Using model targets";
      this.globalSettings.taxableCashMinPerc = null;
      this.globalSettings.taxableCashMaxPerc = null;
      this.globalSettings.taxableCashTargetPerc = null;
      this.globalSettings.taxableCashMinDollarAmnt = null;
      this.globalSettings.qualifiedCashMinPerc = null;
      this.globalSettings.qualifiedCashMaxPerc = null;
      this.globalSettings.qualifiedCashTargetPerc = null;
      this.globalSettings.qualifiedCashMinDollarAmnt = null;
    } else {
      this.cashSettingsPlaceholder = this.cashSettingsPlaceholderDefault;
      this.cashSettingsPlaceholderDollar = this.cashSettingsPlaceholderDollarDefault;
      this.globalSettings.taxableCashMinPerc = this.originalGlobalSettings.taxableCashMinPerc;
      this.globalSettings.taxableCashMaxPerc = this.originalGlobalSettings.taxableCashMaxPerc;
      this.globalSettings.taxableCashTargetPerc = this.originalGlobalSettings.taxableCashTargetPerc;
      this.globalSettings.taxableCashMinDollarAmnt = this.originalGlobalSettings.taxableCashMinDollarAmnt;
      this.globalSettings.qualifiedCashMinPerc = this.originalGlobalSettings.qualifiedCashMinPerc;
      this.globalSettings.qualifiedCashMaxPerc = this.originalGlobalSettings.qualifiedCashMaxPerc;
      this.globalSettings.qualifiedCashTargetPerc = this.originalGlobalSettings.qualifiedCashTargetPerc;
      this.globalSettings.qualifiedCashMinDollarAmnt = this.originalGlobalSettings.qualifiedCashMinDollarAmnt;
    }

    this.cdr.detectChanges();
  }

  onUseModelCashInputChange() {
    this.onUseModelCashChange();
    this.onInputChange();
  }

  onSMAAllowedChange() {
    this.iss.getSMANotAllowed().subscribe((data: any) => {
      const response = data as ISMANotAllowedResponse;
      
      if(response.responseStatus === "SUCCESS") {
        if(response.responseData) {
          this.globalSettings.isSMAallowed = true;
          this.onInputChange();

          this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            msg: "To prevent use of SMA accounts and securities in your iRebal environment, you must delete all SMA securities and reset all SMA accounts. To do this:\n\n1. Go to the assigned accounts page, sort by SMA symbol, and change all SMA accounts to non-SMA accounts.\n\n2. Then go to the security master, filter for securities with type = SMA, and delete the SMA securities."
          } as IAlertDialogData);
        } else {
          this.onInputChange();
        }
      }
    },() => {
      this.globalSettings.isSMAallowed = true;
      this.onInputChange();
    });
  }

  onSMAAllowedPosClick() {
    this.onInputChange();
  }

  onSMAAllowedNegClick() {
    this.onSMAAllowedChange();
  }

  onShowExternalAccountsChange() {
      this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
        msg: "This will delete all external accounts and their holdings.",
        dCancelBtnLabel: "Cancel",
        onCancel: (() => {
          window.setTimeout(() => {
            this.globalSettings.showExternalAccounts = true;
            this.onInputChange();
          });
        }).bind(this),
        onProceed: (() => {
          this.onInputChange();
        }).bind(this)
      } as IAlertDialogData);
  }

  validateInput(): Observable<string[]> {
    this.validationErrors = [];
    this.validationErrorTemplates = [];

    if(this.globalSettings.taxableCashMinPerc != null && this.taxableCashMinPerc &&
      this.taxableCashMinPerc?.inputControl.invalid) {
        this.validationErrors.push("");
    }

    if(this.globalSettings.taxableCashMinDollarAmnt != null && this.taxableCashMinDollarAmnt &&
      this.taxableCashMinDollarAmnt?.inputControl.invalid) {
        this.validationErrors.push("");
    }

    if(this.globalSettings.taxableCashMaxPerc != null && this.taxableCashMaxPerc &&
      this.taxableCashMaxPerc?.inputControl.invalid) {
        this.validationErrors.push("");
    }

    if(this.globalSettings.qualifiedCashMinPerc != null && this.qualifiedCashMinPerc &&
      this.qualifiedCashMinPerc?.inputControl.invalid) {
        this.validationErrors.push("");
    }

    if(this.globalSettings.taxableCashTargetPerc != null && this.taxableCashTargetPerc &&
      this.taxableCashTargetPerc?.inputControl.invalid) {
        this.validationErrors.push("");
    }

    if(this.isCashEqvEnabled && (this.globalSettings.taxableTrxCashMinValue == null ||
             this.taxableTrxCashMinValueRef?.inputControl?.invalid)) {
        this.validationErrors.push("");
    }
    if(this.globalSettings.qualifiedCashTargetPerc != null && this.qualifiedCashTargetPerc &&
      this.qualifiedCashTargetPerc?.inputControl.invalid) {
        this.validationErrors.push("");
    }

    if(this.globalSettings.qualifiedCashMinDollarAmnt != null && this.qualifiedCashMinDollarAmnt &&
      this.qualifiedCashMinDollarAmnt?.inputControl.invalid) {
        this.validationErrors.push("");
    }

    if(this.globalSettings.qualifiedCashMaxPerc != null && this.qualifiedCashMaxPerc &&
      this.qualifiedCashMaxPerc?.inputControl.invalid) {
        this.validationErrors.push("");
    }

    if (this.isCashEqvEnabled && (this.globalSettings.quailifiedTrxCashMinValue == null ||
           this.quailifiedTrxCashMinValueRef?.inputControl?.invalid)) {
        this.validationErrors.push("");
    }

    if(this.globalSettings.autoCashHoldForDist && !this.globalSettings.autoCashHoldForDistWindow ||
      this.autoCashHoldForDistWindow?.inputControl.invalid) {
        this.validationErrors.push("");
    }

    return of(this.validationErrors);
  }

  load(data: IGlobalSettings) {
    this.taxableTrxCashMinValue = data.taxableTrxCashMinValue;
    this.quailifiedTrxCashMinValue = data.quailifiedTrxCashMinValue;
    this.globalSettings = data;
    this.globalSettings.currentSetting = "accountView";
    if(this.globalSettings) {
      this.dataTransferService.ShowExternalAccounts = this.globalSettings.showExternalAccounts;
      this.dataTransferService.ShowSMASymbol = this.globalSettings.isSMAallowed;
    }    
    this.originalGlobalSettings = this.util.clone(this.globalSettings);
    this.isModified = false;
    //this.showUnsavedChangesWarning = false;
    this.as.fireEvent(IrbSettingsEvents.IS_NOT_MODIFIED);
    this.onUseModelCashChange();
    this.cdr.detectChanges();
  }

  save() {
    this.validateInput().subscribe(validationErrors => {
      if(validationErrors.length === 0) {
        this.as.fireEvent(IrbSettingsEvents.SAVE_START);

        this.iss.saveAccountsGlobalSettings(this.globalSettings).subscribe((data: any) => {
          const response = data as IGlobalSettingsSaveResponse;
        
          if(response.responseStatus === "SUCCESS") {
              this.iss.getGlobalSettings().subscribe((saveData: any) => {
                if(!this.originalGlobalSettings.isSMAallowed && saveData.isSMAallowed) {
                  this.ps.pageState.accountGridDiv["isSMAallowed"] = "true";
                  this.ps.serializePageState();
                }
                if (this.originalGlobalSettings.isSMAallowed !== saveData.isSMAallowed) {
                  this.as.extractFromSession("editor-account");
                }

                this.as.fireEvent(IrbSettingsEvents.SAVE_SUCCESS, "Account settings were updated.");
                this.as.fireEvent(IrbSettingsEvents.GLOBAL_SETTINGS_REFRESH);
                this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
                this.load(saveData as IGlobalSettings);
              });              
          } else if (response.responseStatus === "STALEDATAEXCEPTION") {
            this.refreshRequired();
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          }
          else {
            this.as.fireEvent(IrbSettingsEvents.SAVE_ERROR);
          }
        },() => {
          this.as.fireEvent(IrbSettingsEvents.SAVE_ERROR);
        });

        if(this.globalSettings) {
          this.dataTransferService.ShowExternalAccounts = this.globalSettings.showExternalAccounts;
          this.dataTransferService.ShowSMASymbol = this.globalSettings.isSMAallowed;
        }
      } else {
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Save',
            detail: "Please correct invalid entries before saving."
        });
      }
    });
  }

  refreshRequired(){
    this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
      dTitle: 'Refresh Required',
      dProceedBtnLabel: 'Refresh',
      msg: "You are attempting to edit an account that was just modified by someone else. To see the updated account, please refresh the page.",
      onProceed: (() => {
        this.refreshData();
      })
    } as IAlertDialogData);
  }

  processEvent(event: IEvent) {
    switch(event.type) {
      case IrbSettingsEvents.SAVE: 
        this.save();
        break;
      case IrbSettingsEvents.UNSAVED_CHANGES:
        if(this.isModified) {
          this.showUnsavedChangesWarning = true;
          this.cdr.detectChanges();
        }
        break;
      case IrbSettingsEvents.REVERT_CHANGES:
        this.revert();
        break;
      case IrbSettingsEvents.EXPAND_AUTO_CASH:
        this.autoCashPanel.expanded = true;
        break;
    }
  }

  revert() {
    if(this.isModified) {
      this.load(this.originalGlobalSettings);
    }
  }

  get globalSettings() {
    return this._globalSettings;    
  }

  set globalSettings(newGlobalSettings: IGlobalSettings) {
    this._globalSettings = newGlobalSettings;
  }

  get isModified() {
    return this._isModified;
  }

  set isModified(newIsModified: boolean) {
    this._isModified = newIsModified;
  }

  get isadmin() {
    return this._isadmin;
  }

  set isadmin(isadmin: boolean) {
    this._isadmin = isadmin;
  }

  isDisabled() {
    return (!this.isadmin)?true:(this.globalSettings?.externalAccountsAPIEnabled)?true:false;
  }

  validateReinvestChange() {
    if(this.isadmin) {
      const isTaxableReinvestValid = !(this.globalSettings.isDividendReinvestTaxable === true && this.globalSettings.isCapGainsReinvestTaxable === false);
      const isQualifiedReinvestValid = !(this.globalSettings.isDividendReinvestQualified === true && this.globalSettings.isCapGainsReinvestQualified === false);

      if(!isTaxableReinvestValid || !isQualifiedReinvestValid) {
        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
          msg: "You have selected an unsupported reinvestment election.",
          altMsgTemplate: this.reinvestUnsupportedConfigMessage,
          dType: "WARN"
        } as IAlertDialogData);
        
        setTimeout(() => {
          if(!isTaxableReinvestValid) {
            this.globalSettings.isCapGainsReinvestTaxable = true;
          }

          if(!isQualifiedReinvestValid) {
            this.globalSettings.isCapGainsReinvestQualified = true;
          }
          
          this.onInputChange();
        });
      } else {
        this.onInputChange();
      }
    }
  }

  openAutomatedTradingTab() {
    this.as.fireEvent(IrbSettingsEvents.SHOW_TAB, {tabIndex: 6});
  }

  openAccountsInventory() {
    this.as.fireEvent(IrbSettingsEvents.NAVIGATE, {url: "/clients/accounts"});
  }

  showEnableAutoCashHoldConfirmation() {
      this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
        dTitle: "Disable Automatic Cash Holds for Distribution?",
        dWidth: 540,
        altMsgHTML: "<div class='block'>Turning this feature off will stop all automatic cash holds for distribution in your portfolios. This feature will not operate while the setting is disabled.</div>Note: Individual account settings will not be changed.",
        dCancelBtnLabel: "Cancel",
        dProceedBtnLabel: "Yes, disable",
        onProceed: () => {
          this.toggleAutoCashHoldForDist();
        },
        onCancel: () => {
          this.globalSettings.autoCashHoldForDist = true;
        }
      } as IAlertDialogData);
  }
  
  toggleAutoCashHoldForDist() {
    if(!this.globalSettings.autoCashHoldForDist) {
      this.globalSettings.autoCashHoldForAllFutureAccounts = false;
    } else {
      this.globalSettings.autoCashHoldForAllFutureAccounts = true;
    }

    this.onInputChange();
  }

  showEnableAutoCashHoldForAllAcctConfirmation() {
    this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
      dTitle: "Turn on for all accounts?",
      altMsgHTML: "<div class='block'>Turning this feature on will override any previous configuration of this feature on all of your accounts.</div>Would you like to continue?",
      dCancelBtnLabel: "Cancel",
      dProceedBtnLabel: "Turn on for all accounts",
      onProceed: () => {
        this.enableAutoCashHoldForAllAcct();
      }
    } as IAlertDialogData);
  }

  enableAutoCashHoldForAllAcct() {
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

    this.iss.enableAutoCashHoldForAllAcct().subscribe((_res: any) => {
	    this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    },() => { this.as.fireEvent(IrbAppEvents.HIDE_WAIT); });
  }
}
